export const CodePreviewWithTitle = {
  extends: 'Group',
  tag: 'pre',
  margin: '- 0 0',
  Title: {
    order: null,
    tag: 'h5',
    text: 'Code Example',
    fontFamily: 'smbls',
    color: 'caption',
    fontSize: 'Z',
    fontWeight: '500',
    whiteSpace: 'nowrap',
  },
  CodePreview: {
    margin: '0 -Y1',
  },
};